import Page from 'components/Page';
import UpdateStore from './components/UpdateStore/UpdateStore';
interface Props {}
const UpdateStorePromotion = (props: Props) => {
  return (
    <Page>
      <UpdateStore></UpdateStore>
    </Page>
  );
};

export default UpdateStorePromotion;
